var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment-header"},[_c('header',[_c('span',{staticClass:"title32B"},[_vm._v("全部评论("+_vm._s(_vm.count || '')+")")])]),_c('toggle-rule')],1)}
var staticRenderFns = []

export { render, staticRenderFns }